import LayoutWrapper from "../../LayoutWrapper";
import MarketplacePartners from "../../MarketplacePartners";

export default function PartnersList() {
    return (
        <LayoutWrapper model="marketplace" renderOpsBar={false}>
            <MarketplacePartners allowDownloadCsvLink={true} allowLayoutSelection={true} enableDomainSelection={false} />
        </LayoutWrapper>
    )
}